import script from "./UserDeleteDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDeleteDialog.vue?vue&type=script&setup=true&lang=js"

import "./UserDeleteDialog.vue?vue&type=style&index=0&id=b9e9534a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9e9534a"]])

export default __exports__